<script>
import imagesLoaded from 'imagesloaded';
import Isotope from 'isotope-layout';

import animation from '../partials/components/animate.vue';
import portfolioFilter from '../partials/components/portfolio-filter.vue';

export default {
    components: { animation, portfolioFilter },

    data() {
        return {
            filter: 'residential',
            iso: null
        };
    },

    mounted() {
        const imgProcessor = new imagesLoaded(this.$refs.projects, this.isotopePort);
    },

    methods: {
        processHash() {
            const hash = location.hash.substring(1);

            if (hash === 'residential' || hash === 'commercial') {
                this.filter = hash;
                this.applyFilter();
            }
        },

        isotopePort() {
            this.iso = new Isotope(this.$refs.projects, {
                itemSelector: '[data-project-card]',
                layoutMode: 'fitRows',
                filter: `[data-filter-${this.filter}]`
            });

            this.processHash();
        },

        applyFilter() {
            this.iso.arrange({ filter: `[data-filter-${this.filter}]` });
        }
    }
};
</script>
